import { Amplify } from 'aws-amplify';

const config = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || 'us-east-1_NmMWYYKII',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '1e0so7jkqpn97tnrgl7tdoqdtb',
      loginWith: {
        oauth: {
          domain: 'shitlistpoll.auth.us-east-1.amazoncognito.com',
          scopes: ['email', 'openid', 'phone', 'profile'],
          redirectSignIn: ['https://shitlistpoll.com/auth/callback'],
          redirectSignOut: ['https://shitlistpoll.com/'],
          responseType: 'code' as 'code'
        }
      }
    }
  }
};

Amplify.configure(config);